__turbopack_context__.v({
  "container": "_3VkBja_container",
});
